function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  fill: "rgb(213, 213, 213)",
  d: "M0.268,4.397 L4.420,0.247 C4.747,-0.081 5.278,-0.081 5.606,0.247 C5.933,0.574 5.933,1.105 5.606,1.432 L2.048,4.989 L5.606,8.546 C5.933,8.873 5.933,9.404 5.606,9.732 C5.278,10.059 4.747,10.059 4.420,9.732 L0.268,5.581 C-0.059,5.255 -0.059,4.724 0.268,4.397 ZM5.260,4.146 L8.556,0.673 C8.887,0.324 9.424,0.324 9.755,0.673 C10.086,1.021 10.086,1.587 9.755,1.936 L7.058,4.777 L9.755,7.618 C10.086,7.966 10.086,8.532 9.755,8.881 C9.424,9.229 8.887,9.229 8.556,8.881 L5.260,5.408 C4.929,5.060 4.929,4.494 5.260,4.146 Z"
});

var SvgFirstPage = function SvgFirstPage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "10px",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFirstPage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/firstPage.d244f4ea.svg";
export { ForwardRef as ReactComponent };